import {IEventData, EEventSource} from 'coreClasses/events/IEvents';
import {IAnalyticsEvent} from 'coreClasses/analytics/IAnalytics';

import {EAnalyticsEventSource, EAnalyticsEventType} from 'brandClasses/analytics/EAnalyticsEvent';
import {DATALAYER_CONFIGS} from 'brandConstants';

import ProductItemEvent from './common/ProductItemEvent';

/**
 * Represents ViewItemListEvent
 */
export default class ViewItemListEvent implements IAnalyticsEvent {
	public event: string;
	public event_trigger: string;
	public ecommerce: any;

	/**
	 * @constructor
	 * @param {IEventData} data - data
	 */
	constructor(data: IEventData) {
		const eventSourceCategoryId: string = data.eventSourceCategoryId;
		const eventSourceCategoryName: string = data.eventSourceCategoryName;
		const currency: string = data.currency;
		const productsData = data.productsData?.slice(0, DATALAYER_CONFIGS.viewItemListMaxProducts);
		const source = EAnalyticsEventSource[EEventSource[data.source]];

		const items = productsData.map((productData) => {
			return {
				...new ProductItemEvent({
					product: productData.product,
					source: source,
					index: productData.position,
					productCategoriesIds: productData.productCategoriesIds,
					eventSourceCategoryId: productData?.product?.getPrimaryCategoryId(),
					eventSourceCategoryName: productData?.eventSourceCategoryName,
				})
			};
		});

		this.event = EAnalyticsEventType.VIEW_ITEM_LIST;
		this.event_trigger = 'ecomm';
		this.ecommerce = {
			item_list_id: source,
			plp_category_id: eventSourceCategoryId,
			plp_category_name: eventSourceCategoryName,
			currency: currency,
			items,
		};
	}
}
